// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incyia-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  min-height: 220px;
  margin: 12px 16px 20px;
  padding: 36px 24px;
  border-radius: 14px;
  background: linear-gradient(180deg, #f7fafb 0%, #f1f4fa 100%);
  border: 1px dashed #d5dde8;
  font-family: Lato, sans-serif;
}

.incyia-empty.is-compact {
  min-height: 160px;
  margin: 8px;
  padding: 28px 18px;
}

.incyia-empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  margin-bottom: 6px;
  background: #e8f6f3;
  color: #076b5c;
}

.incyia-empty-icon svg {
  width: 24px;
  height: 24px;
}

.incyia-empty-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0b1e2d;
  letter-spacing: 0.01em;
}

.incyia-empty-hint {
  margin: 0;
  max-width: 320px;
  font-size: 13px;
  line-height: 1.45;
  color: #5f7484;
}

.incyia-empty--loading {
  border-style: solid;
  border-color: #e2e8f0;
  background: linear-gradient(180deg, #ffffff 0%, #f7fafb 100%);
}

.incyia-empty-spinner {
  width: 28px;
  height: 28px;
  margin-bottom: 8px;
  border-radius: 50%;
  border: 2.5px solid #dfe7e8;
  border-top-color: #0d9b87;
  animation: incyia-spin 0.7s linear infinite;
}

@keyframes incyia-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Keep legacy class usable as a layout wrapper */
.incyia-table-empty {
  padding: 0;
  text-align: center;
  color: inherit;
  font-size: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/TableEmptyState.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".incyia-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 6px;\n  min-height: 220px;\n  margin: 12px 16px 20px;\n  padding: 36px 24px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #f7fafb 0%, #f1f4fa 100%);\n  border: 1px dashed #d5dde8;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-empty.is-compact {\n  min-height: 160px;\n  margin: 8px;\n  padding: 28px 18px;\n}\n\n.incyia-empty-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  margin-bottom: 6px;\n  background: #e8f6f3;\n  color: #076b5c;\n}\n\n.incyia-empty-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.incyia-empty-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0b1e2d;\n  letter-spacing: 0.01em;\n}\n\n.incyia-empty-hint {\n  margin: 0;\n  max-width: 320px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.incyia-empty--loading {\n  border-style: solid;\n  border-color: #e2e8f0;\n  background: linear-gradient(180deg, #ffffff 0%, #f7fafb 100%);\n}\n\n.incyia-empty-spinner {\n  width: 28px;\n  height: 28px;\n  margin-bottom: 8px;\n  border-radius: 50%;\n  border: 2.5px solid #dfe7e8;\n  border-top-color: #0d9b87;\n  animation: incyia-spin 0.7s linear infinite;\n}\n\n@keyframes incyia-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Keep legacy class usable as a layout wrapper */\n.incyia-table-empty {\n  padding: 0;\n  text-align: center;\n  color: inherit;\n  font-size: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
